import { IWobBaseConstParam, WobBase } from './WobBase'
import { IAloLogbookItemConstParam, AloLogbookItem } from '../alo/AloLogbookItem'

export interface IWobLogbookChangedConstParam extends IWobBaseConstParam {
  actionType: string
  logbookItem: IAloLogbookItemConstParam
}

export class WobLogbookChanged extends WobBase  {  
  public actionType: string
  public logbookItem: AloLogbookItem

  constructor({ actionType, logbookItem, ...args }: IWobLogbookChangedConstParam = {} as IWobLogbookChangedConstParam) {    
    super(args)
    this.actionType = actionType
    this.logbookItem = AloLogbookItem.createAloLogbookItem(logbookItem)
  }

}
